var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.95 42 9.45 34.05V22.05L2 18L23.95 6L46 18V33.85H43V19.75L38.45 22.05V34.05ZM23.95 26.6 39.7 18 23.95 9.55 8.3 18ZM23.95 38.6 35.45 32.25V23.85L23.95 30L12.45 23.75V32.25ZM24 26.6ZM23.95 30.3ZM23.95 30.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.0fac4b3d41bf324d9c385e44442825e7.svg";
export { ForwardRef as ReactComponent };